import { render, staticRenderFns } from "./formExt.vue?vue&type=template&id=1f6f6630&scoped=true"
import script from "./formExt.vue?vue&type=script&lang=js"
export * from "./formExt.vue?vue&type=script&lang=js"
import style0 from "./formExt.vue?vue&type=style&index=0&id=1f6f6630&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f6630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f6f6630')) {
      api.createRecord('1f6f6630', component.options)
    } else {
      api.reload('1f6f6630', component.options)
    }
    module.hot.accept("./formExt.vue?vue&type=template&id=1f6f6630&scoped=true", function () {
      api.rerender('1f6f6630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/kms_new/views/backstage_manage/interface_parameters/form/components/formExt.vue"
export default component.exports